/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Initial_Role_EnabledInputs */

const en_admin_settings_fields_initial_role_enabled = /** @type {(inputs: Admin_Settings_Fields_Initial_Role_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto-assign role for new users`)
};

const zh_admin_settings_fields_initial_role_enabled = /** @type {(inputs: Admin_Settings_Fields_Initial_Role_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新用户自动分配角色`)
};

/**
* | output |
* | --- |
* | "Auto-assign role for new users" |
*
* @param {Admin_Settings_Fields_Initial_Role_EnabledInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_initial_role_enabled = /** @type {((inputs?: Admin_Settings_Fields_Initial_Role_EnabledInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Initial_Role_EnabledInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_fields_initial_role_enabled(inputs)
	return zh_admin_settings_fields_initial_role_enabled(inputs)
});
export { admin_settings_fields_initial_role_enabled as "admin.settings.fields.initial_role_enabled" }